import AbstractRestApi from '@/api/RestApi/AbstractRestApi'
import promotionType from '@/enum/promotionType'
import { mergePromotionUsers } from '@/services/Promotions/PromotionUsers'

class PromotionsApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/promotions'
    }

    create(entity, headers) {
        return super.create(this.stripLoadedUsers(entity), headers)
    }

    // Sends the user list as a delta against the list the form loaded, so a user
    // whose voucher was consumed since the form was opened is not re-added.
    update(entity, id) {
        if (
            entity.promotionType !== promotionType.user ||
            !Array.isArray(entity.loadedUsers)
        ) {
            return super.update(this.stripLoadedUsers(entity), id)
        }

        return this.get(id).then((current) => {
            const payload = this.stripLoadedUsers(entity)
            payload.users = mergePromotionUsers(
                current.users,
                entity.loadedUsers,
                entity.users
            )

            return super.update(payload, id)
        })
    }

    stripLoadedUsers(entity) {
        const payload = { ...entity }
        delete payload.loadedUsers

        return payload
    }
}

export default new PromotionsApiClient()
